
interface Source {
  text: string;
  link: string;
}

interface SourcesListProps {
  sources: Source[];
}

const SourcesList = ({ sources }: SourcesListProps) => {
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className="mt-28 pt-16 border-t border-border/60">
      <h3 className="text-2xl font-semibold mb-10">Sources</h3>
      <div className="space-y-8">
        {sources.map((source, index) => (
          <div key={index} className="text-base text-muted-foreground hover:bg-muted/40 p-6 rounded-lg transition-colors">
            <a 
              href={source.link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors"
            >
              {source.text}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SourcesList;
